import { createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/plane-booking.svg'
import _imports_1 from '@/app/ui/assets/svg/arrow-right-gray.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-9cd808bc")

_pushScopeId("data-v-9cd808bc")
const _hoisted_1 = { class: "flex flex-row items-center space-x-4 justify-between" }
const _hoisted_2 = { class: "flex gap-x-4" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-10",
  alt: ""
}, null, -1)
const _hoisted_4 = { class: "flex flex-col" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "text-20px font-semibold text-black-lp-300" }, " Kargo Pesawat ", -1)
const _hoisted_6 = { class: "flex flex-row space-x-2 items-center" }
const _hoisted_7 = { class: "\n                text-12px\n                xxl:text-14px\n                font-medium\n                text-gray-lp-600\n                whitespace-no-wrap\n              " }
const _hoisted_8 = /*#__PURE__*/_createVNode("img", {
  src: _imports_1,
  class: "w-6",
  alt: ""
}, null, -1)
const _hoisted_9 = { class: "\n                text-12px\n                xxl:text-14px\n                font-medium\n                text-gray-lp-600\n                pr-2\n                whitespace-no-wrap\n              " }
const _hoisted_10 = { class: "\n                text-12px\n                xxl:text-14px\n                flex flex-row\n                font-medium\n                text-gray-lp-600\n                pl-2\n                items-center\n              " }
const _hoisted_11 = {
  key: 1,
  class: "whitespace-no-wrap"
}
const _hoisted_12 = { class: "\n                text-12px\n                xxl:text-14px\n                font-medium\n                text-gray-lp-600\n                pl-2\n                whitespace-no-wrap\n              " }
const _hoisted_13 = { class: "flex pt-6 flex-row space-x-4" }
const _hoisted_14 = { class: "flex flex-row p-3" }
const _hoisted_15 = /*#__PURE__*/_createVNode("div", { class: "text-12px xxl:text-14px font-semibold text-black-lp-300 pr-1" }, " Total berat ", -1)
const _hoisted_16 = { class: "text-12px xxl:text-14px font-semibold text-red-lp-100" }
const _hoisted_17 = { class: "flex flex-row p-3" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "text-12px xxl:text-14px font-semibold text-black-lp-300 pr-1" }, " Total berat volume ", -1)
const _hoisted_19 = { class: "text-12px xxl:text-14px font-semibold text-red-lp-100" }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "py-2" }, [
  /*#__PURE__*/_createVNode("hr", { class: "border-gray-lp-400" })
], -1)
const _hoisted_21 = {
  key: 1,
  class: "space-y-6 pt-6"
}
const _hoisted_22 = { class: "text-12px xxl:text-14px text-gray-lp-600 pt-1 pb-3" }
const _hoisted_23 = { class: "w-full grid gap-6" }
const _hoisted_24 = { class: "text-16px text-black-lp-300 font-semibold pb-3" }
const _hoisted_25 = { class: "space-y-3" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_Card = _resolveComponent("Card")!
  const _component_LayoutSchedule = _resolveComponent("LayoutSchedule")!
  const _component_HeaderScheduleCard = _resolveComponent("HeaderScheduleCard")!
  const _component_HorizontalScrollContainer = _resolveComponent("HorizontalScrollContainer")!
  const _component_ScheduleCard = _resolveComponent("ScheduleCard")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_CargoProcessCargo = _resolveComponent("CargoProcessCargo")!

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, _toDisplayString(_ctx.form.airports[0].airportCode) + " - " + _toDisplayString(_ctx.firstCapitalize(_ctx.form.airports[0].cityName)), 1),
            _hoisted_8,
            _createVNode("div", _hoisted_9, _toDisplayString(_ctx.form.airports[_ctx.form.airports.length - 1].airportCode) + " - " + _toDisplayString(_ctx.firstCapitalize(_ctx.form.airports[_ctx.form.airports.length - 1].cityName)), 1),
            _createVNode("div", _hoisted_10, [
              _createVNode("div", {
                class: 
                  `${
                    _ctx.isShowDate ? 'w-1/2' : ''
                  } text-12px xxl:text-14px font-medium text-gray-lp-600 border-l ${
                    _ctx.labelTransit ? 'border-r' : ''
                  } border-gray-lp-400 px-4`
                
              }, [
                (_ctx.isShowDate)
                  ? (_openBlock(), _createBlock(_component_Datepicker, {
                      key: 0,
                      modelValue: _ctx.form.estDepartureDate,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.estDepartureDate = $event)),
                      showIcon: false,
                      minDate: new Date(),
                      class: "w-full",
                      customClass: "m-0",
                      height: 2,
                      onSelected: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onGetFlightSchedule(_ctx.form.flightsData.length)))
                    }, null, 8, ["modelValue", "minDate"]))
                  : (_openBlock(), _createBlock("span", _hoisted_11, _toDisplayString(_ctx.estDepartureDate), 1))
              ], 2)
            ]),
            _createVNode("div", _hoisted_12, _toDisplayString(_ctx.labelTransit), 1)
          ])
        ])
      ]),
      _createVNode("div", null, [
        _createVNode(_component_lp_button, {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('change-airport'))),
          "text-color": "white",
          title: "Ubah Pencarian",
          disabled: _ctx.isLoadingSearchFlight
        }, null, 8, ["disabled"])
      ])
    ]),
    _createVNode("div", _hoisted_13, [
      _createVNode(_component_Card, null, {
        default: _withId(() => [
          _createVNode("div", _hoisted_14, [
            _hoisted_15,
            _createVNode("div", _hoisted_16, _toDisplayString(_ctx.actualGrossWeight) + " Kg ", 1)
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_Card, null, {
        default: _withId(() => [
          _createVNode("div", _hoisted_17, [
            _hoisted_18,
            _createVNode("div", _hoisted_19, _toDisplayString(_ctx.actualVolumeWeight) + " Kg ", 1)
          ])
        ]),
        _: 1
      })
    ]),
    _hoisted_20,
    (_ctx.flagFeatureFlight)
      ? (_openBlock(), _createBlock(_component_LayoutSchedule, {
          key: 0,
          data: _ctx.searchFlight,
          isLoading: _ctx.isLoadingSearchFlight,
          error: _ctx.errorCauseSearchFlight,
          onOnChangeSearch: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('change-airport'))),
          onOnReload: _cache[5] || (_cache[5] = ($event: any) => (_ctx.getSearchFlight()))
        }, null, 8, ["data", "isLoading", "error"]))
      : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
          (_ctx.form.airports.length > 2)
            ? (_openBlock(), _createBlock(_component_HorizontalScrollContainer, {
                key: 0,
                "hide-toggle": true
              }, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.scheduleFlight, (item, index) => {
                    return (_openBlock(), _createBlock(_component_HeaderScheduleCard, {
                      style: {"flex-shrink":"0"},
                      onRequest: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onGetFlightSchedule(_ctx.form.flightsData.length))),
                      class: "mr-6 overflow-hidden",
                      key: index,
                      index: index,
                      data: item
                    }, null, 8, ["index", "data"]))
                  }), 128))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.isLoading)
            ? (_openBlock(), _createBlock("div", _hoisted_21, [
                (_openBlock(), _createBlock(_Fragment, null, _renderList(4, (i) => {
                  return _createVNode(_component_ScheduleCard, {
                    key: i,
                    isLoading: true
                  })
                }), 64))
              ]))
            : (_ctx.errorData.type && !_ctx.isLoading)
              ? (_openBlock(), _createBlock(_component_ErrorMessage, {
                  key: 2,
                  errorTitle: _ctx.errorData.title,
                  isShowTitle: !!_ctx.errorData.title,
                  errorType: _ctx.errorData.type,
                  errorImage: _ctx.errorData.icon,
                  errorMessage: _ctx.errorData.message
                }, null, 8, ["errorTitle", "isShowTitle", "errorType", "errorImage", "errorMessage"]))
              : (_ctx.filteredFlightSchedules.length === 0)
                ? (_openBlock(), _createBlock(_component_ErrorMessage, {
                    key: 3,
                    isShowTitle: false,
                    "error-type": "not-found",
                    "error-message": "Maaf, jadwal keberangkatan kargo pesawat sudah penuh atau tidak tersedia.",
                    "error-image": "flight-schedule-not-found"
                  }))
                : (_openBlock(), _createBlock(_Fragment, { key: 4 }, [
                    _createVNode("div", _hoisted_22, _toDisplayString(_ctx.labelPlaneSchedule), 1),
                    _createVNode("div", _hoisted_23, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filteredFlightSchedules, (flights, date) => {
                        return (_openBlock(), _createBlock("div", { key: date }, [
                          _createVNode("div", _hoisted_24, _toDisplayString(_ctx.moment(date).format("DD MMMM YYYY")), 1),
                          _createVNode("div", _hoisted_25, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(flights, (item, index) => {
                              return (_openBlock(), _createBlock(_component_ScheduleCard, {
                                width: "w-3/4",
                                key: index,
                                data: item,
                                onSelectTransit: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onGetFlightSchedule(_ctx.form.flightsData.length))),
                                onBookingCargo: _ctx.handleConfirmation
                              }, null, 8, ["data", "onBookingCargo"]))
                            }), 128))
                          ])
                        ]))
                      }), 128))
                    ]),
                    _withDirectives(_createVNode("div", null, [
                      _createVNode(_component_CargoProcessCargo, {
                        ref: "bookingCargo",
                        onLeavePage: _ctx.onLeavePage
                      }, null, 8, ["onLeavePage"])
                    ], 512), [
                      [_vShow, false]
                    ])
                  ], 64))
        ], 64))
  ]))
})